import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { connect } from 'react-redux';

import * as SearchActions from '~app/actions/search';

import defined from '~app/core/defined';

import IconButton from './IconButton';

class SearchBar extends Component {

  state = {
    lastSearch: null,
  };

  static propTypes = {
    searchTerm: PropTypes.string,
    selectionMode: PropTypes.number.isRequired,
  };

  onChange(event) {
    // Do not allow the clear button to show up after the last issued search
    // has been modified. This guards against the search being modified and then
    // restored to the last issued search.
    this.setState({
      lastSearch: null,
    });

    this.props.setSearchTerm(event.target.value);
  }

  onKeyDown(event) {
    // Execute the search when 'return' is pressed down.
    if (event.key === "Enter") {
      this.issueSearch();
    }
  }

  issueSearch() {
    this.setState({
      lastSearch: this.props.searchTerm,
    });

    this.props.executeSearchQuery(this.props.searchTerm);
  }

  clearSearch() {
    this.setState({
      lastSearch: null,
    });

    this.props.clearSearchTerm();

    if (this.props.selectionMode === SearchActions.SelectionMode.select) {
      // Only clear the selection on an outside tap if we are in select mode.
      // In compare mode, we want to keep the original selection intact so that
      // our second pick can compare against it.
      this.props.clearSelection();
      this.props.clearPins();
    }
  }

  componentDidUpdate() {
    // If the search term is no longer defined, that is our cue to remove
    // focus from the text input.
    if (!defined(this.props.searchTerm)) {
      this.textInput.blur();
    }
  }

  render() {
    return (
      <div className="SearchBar">
        <input
          ref={element => this.textInput = element}
          className="SearchBar__textInput"
          type="text"
          placeholder="Search by place or lat,long"
          value={this.props.searchTerm || ''}
          onChange={::this.onChange}
          onKeyDown={::this.onKeyDown}
        />
        {this.renderButton()}
      </div>
    );
  }

  renderButton() {
    let jsx = null;
    if (defined(this.state.lastSearch) &&
        this.state.lastSearch === this.props.searchTerm) {
      // Render the clear button.
      jsx = (
        <IconButton
          styleName={'SearchBar__clearButton'}
          onClick={::this.clearSearch}
        />
      );
    }
    else {
      // Render the search button.
      jsx = (
        <IconButton
          styleName={'SearchBar__searchButton'}
          onClick={::this.issueSearch}
        />
      );
    }
    return jsx;
  }
}

const mapStateToProps = (state) => ({
  searchTerm: state.search.searchTerm,
  selectionMode: state.search.selectionMode,
});

const mapDispatchToProps = {
  setSearchTerm: SearchActions.setSearchTerm,
  clearPins: SearchActions.clearPins,
  clearSearchTerm: SearchActions.clearSearchTerm,
  clearSelection: SearchActions.clearSelection,
  executeSearchQuery: SearchActions.executeSearchQuery,
};

export default connect(mapStateToProps, mapDispatchToProps)(SearchBar);



// WEBPACK FOOTER //
// ./src/components/SearchBar.js